import React, { useEffect } from "react";
import ReactModal from "react-modal";
import style from "./style.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Select from "../../../../components/select/index";
import useTemplateStore from "../../../../stores/templates";
import useDomainStore from "../../../../stores/domain";
import { GetAllOrganizationsDropdown } from "../../../../../api";
function IsAvailableForModal({ open, onClose, onConfirmClick }) {
  const { isKurvDomain } = useDomainStore();
  const [allOrganizations, setAllOrganizations] = React.useState([]);
  const recordToEdit = useTemplateStore((state) => state.recordToEdit);
  const setRecordToEdit = useTemplateStore((state) => state.setRecordToEdit);

  useEffect(() => {
    GetAllOrganizationsDropdown().then((res) => {
      if (res.success) {
        setAllOrganizations(res.organizations);
      }
    });
  }, []);
  return (
    <>
      <ReactModal isOpen={open} className={`${style.react_modal} ${isKurvDomain ? style.kurv_theme : ""}`}>
        <div className={style.header}>
          <ButtonIcon onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L6.93934 8L3.21967 11.7197C2.92678 12.0126 2.92678 12.4874 3.21967 12.7803C3.51256 13.0732 3.98744 13.0732 4.28033 12.7803L8 9.06066L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L9.06066 8L12.7803 4.28033C13.0732 3.98744 13.0732 3.51256 12.7803 3.21967C12.4874 2.92678 12.0126 2.92678 11.7197 3.21967L8 6.93934L4.28033 3.21967Z"
                fill="#737278"
              />
            </svg>
          </ButtonIcon>
        </div>

        <div className={style.body}>
          <h2
            style={{
              color: "#1E0C3D",
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "32px",
              margin: 0,
            }}
          >
            Available For Organizations
          </h2>
          <div className={style.form_group}>
            <div
              style={{
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <input
                defaultChecked={recordToEdit.is_available_for_all}
                type="checkbox"
                id="selectAll"
                onChange={(e) => {
                  setRecordToEdit({
                    ...recordToEdit,
                    is_available_for_all: e.target.checked,
                  });
                }}
              />
              <label className={style.label}>Available for all</label>
            </div>
            {!recordToEdit.is_available_for_all && (
              <Select
                className={style.input_select}
                options={allOrganizations}
                value={recordToEdit.available_for}
                isMultiSelect={true}
                onChange={(e) => {
                  setRecordToEdit({
                    ...recordToEdit,
                    available_for: e,
                  });
                }}
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100%",
                  }),
                }}
              />
            )}
          </div>
        </div>

        <div className={style.footer_modal}>
          <div className={`${style.button_group} ${style.right}`}>
            <ButtonIcon
              bgColor={isKurvDomain ? "#22A276" : "#4c70ef"}
              textColor="#FFF"
              onClick={() => {
                onConfirmClick(
                  recordToEdit.id,
                  recordToEdit.is_available_for_all,
                  recordToEdit.available_for,
                );
              }}
            >
              Save
            </ButtonIcon>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default IsAvailableForModal;
